export default __webpack_public_path__ + "static/media/Logo_Cleanproplus-white.5ea778da.png";